export default __webpack_public_path__ + "128a28ce449a0c534265babb6ae965c9.jpg";